/**
 * RESPONSIBILITY: one item of the header navigation.
 *
 * Top level and dropdown children are the same row type, told apart by `parent`: empty
 * means it sits in the bar, a name means it sits in that item's panel. One list rather
 * than two is what lets an editor move an item between the two by typing a word.
 */
import { Row, Text, Link, Bool } from '@framework/core/decorators';
import { LINK_HINT } from '../../hints';

@Row()
export class NavLink {
  @Text({ label: 'Title', maxLength: 120, description: 'The words shown in the menu.' })
  label!: string;

  /**
   * Empty for a top-level item. Otherwise the label of the item this sits under —
   * `Ministries` puts it in the Ministries panel.
   */
  @Text({
    label: 'Under', maxLength: 120,
    description: 'Empty puts it in the bar. A title here puts it in that dropdown.',
  })
  parent!: string;

  @Link({ label: 'Link', description: LINK_HINT })
  href!: string;

  /** The one item drawn as a pill rather than a plain link. Visit, in the blueprint. */
  @Bool({ label: 'Highlight', description: 'Draws it as a filled button rather than a plain link.' })
  highlight!: boolean;
}
